export default __webpack_public_path__ + "static/media/Lantechi.5da3f952.png";